<template>
    <div class="data-currentsales">
        <div class="top">
            <div class="top-time">
                <div class="time-select">
                    <span class="iconfont iconshijian"></span>
                    <span class="time" @click="handleShowCalendar(1)">{{ startTime }}</span>
                    <span class="split-line"></span>
                    <span class="iconfont iconshijian"></span>
                    <span class="time" @click="handleShowCalendar(2)">{{ endTime }}</span>
                </div>
                <div class="time-types">
                    <span
                        class="type-item"
                        v-for="item in tabs"
                        :key="item.index"
                        :class="{'active': item.index===activeIndex}"
                        @click="search(item.index)"
                    >{{ item.name }}</span>
                </div>
            </div>
            <div class="color-block">
                <div class="color-item">
                    <div class="num">
                        {{ sumData.sale_volume }}
                    </div>
                    <div class="tip">
                        销售方量(万方)
                    </div>
                </div>
                <div class="color-item">
                    <div class="num">
                        {{ sumData.sale_amount }}
                    </div>
                    <div class="tip">
                        销售金额(万元)
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <template v-if="list.length>0">
                <h4>销量统计列表</h4>
                <div class="address-types">
                    <div
                        class="address-item"
                        v-for="(item, index) in list"
                        :key="item.enterprise_name"
                        :class="`color${index%3}`"
                    >
                        <div class="left">
                            {{ item.short_name }}
                        </div>
                        <div class="right">
                            <div>
                                <div class="num">
                                    {{ item.sale_volume }}
                                </div>
                                <div class="lable">
                                    销售方量(万方)
                                </div>
                            </div>
                            <div>
                                <div class="num">
                                    {{ item.sale_amount }}
                                </div>
                                <div class="lable">
                                    销售收入(万元)
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <div class="empty-data" v-else>
                暂无数据
            </div>
        </div>
        <van-popup v-model="showCalendarPop" position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                v-model="currentDate"
                type="datetime"
                title="选择时间"
                @confirm="confirmDate"
                @cancel="cancelDate"
            ></van-datetime-picker>
        </van-popup>
    </div>
</template>

<script>
import util from '@/utils/util';
export default {
    data() {
        return {
            startTime: '',
            endTime: '',
            tabs: [
                { name: '上一日', index: 1 },
                { name: '本日', index: 2 },
                { name: '本月', index: 3 },
                { name: '上月', index: 4 },
            ],
            activeIndex: 2,
            // 按区域统计列表
            list: [],
            // 合计
            sumData: {},
            // 展示日历
            showCalendarPop: false,
            // 选择时间类型
            choseTimeType: 0,
            // 日历时间
            currentDate: new Date(),
        };
    },
    props: {
        filterData: Object,
    },
    watch: {
        filterData() {
            this.handleStatistics();
        },
    },
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        // 初始化
        init() {
            this.startTime = util.currentTimeFormat('yyyy-MM-dd') + ' 00:00:00';
            this.endTime = util.currentTimeFormat('yyyy-MM-dd') + ' 23:59:59';
            this.handleStatistics();
        },
        // 不同时间段筛选
        search(type) {
            this.activeIndex = type;
            if (type === 1) {
                const preDay = this.getPreDay();
                this.startTime = preDay + ' 00:00:00';
                this.endTime = preDay + ' 23:59:59';
            } else if (type === 2) {
                this.startTime = util.currentTimeFormat('yyyy-MM-dd') + ' 00:00:00';
                this.endTime = util.currentTimeFormat('yyyy-MM-dd') + ' 23:59:59';
            } else if (type === 3) {
                this.startTime = this.getMon().monthStartDate + ' 00:00:00';
                this.endTime = this.getMon().monthEndDate + ' 23:59:59';
            } else if (type === 4) {
                this.startTime = this.getPreMonth().monthStartDate + ' 00:00:00';
                this.endTime = this.getPreMonth().monthEndDate + ' 23:59:59';
            }
            this.handleStatistics();
        },
        // 处理当前销量统计信息（分区域）
        async handleStatistics() {
            const res = await this.getStatistics();
            if (res) {
                this.sumData.sale_volume = res.sale_volume;
                this.sumData.sale_amount = res.sale_amount;
            }
            const data = res.enterpriseSalesDatas;
            data.forEach(item => {
                item.short_name = item.enterprise_name.replace('商混', '').replace('砼享云', '');
            });
            this.list = data;
        },
        // 选择时间
        handleShowCalendar(type) {
            this.choseTimeType = type;
            this.showCalendarPop = true;
        },
        // 确认时间选择
        confirmDate(value) {
            this.showCalendarPop = false;
            if (this.choseTimeType === 1) {
                this.startTime = this.formatDate(value);
            } else {
                this.endTime = this.formatDate(value);
            }
            this.handleStatistics();
        },
        // 取消时间选择
        cancelDate() {
            this.showCalendarPop = false;
        },
        // 时间格式化
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            let d = date.getDate();
            d = d < 10 ? '0' + d : d;
            let h = date.getHours();
            h = h < 10 ? '0' + h : h;
            let mi = date.getMinutes();
            mi = mi < 10 ? '0' + mi : mi;
            let s = date.getSeconds();
            s = s < 10 ? '0' + s : s;
            return y + '-' + m + '-' + d + ' ' + h + ':' + mi + ':' + s;
        },
        // 获取当前销量统计信息（分区域）
        getStatistics() {
            const path = '/interfaceApi/report/SalesReport/get_statistics_cur?startDate=';
            const data = {
                startDate: this.startTime,
                endDate: this.endTime,
                yun_yq_id: this.filterData.yun_yq_id,
                pian_q_id: this.filterData.pian_q_id,
                qi_y_id: this.filterData.qi_y_id,
            };
            return this.$axios.$post(path, data);
        },
        // 上一日
        getPreDay() {
            const time = (new Date()).getTime() - 24 * 60 * 60 * 1000;
            let yesday = new Date(time); // 获取的是前一天日期
            yesday = yesday.getFullYear() + '-' + (yesday.getMonth() > 9 ? yesday.getMonth() + 1 : '0'
            + (yesday.getMonth() + 1)) + '-' + (yesday.getDate() > 9 ? yesday.getDate() : '0' + yesday.getDate()); // 字符串拼接转格式：例如2018-08-19
            return yesday;
        },
        // 本月
        getMon() {
            const now = new Date(); // 当前日期
            const nowMonth = now.getMonth(); // 当前月
            const nowYear = now.getFullYear(); // 当前年
            // 本月的开始时间
            const monthStartDate = new Date(nowYear, nowMonth, 1);
            // 本月的结束时间
            const monthEndDate = new Date(nowYear, nowMonth + 1, 0);
            const monthStartDateStr = monthStartDate.getFullYear() + '-' + (monthStartDate.getMonth() > 9 ? monthStartDate.getMonth() + 1 : '0'
            + (monthStartDate.getMonth() + 1)) + '-' + (monthStartDate.getDate() > 9 ? monthStartDate.getDate() : '0' + monthStartDate.getDate());
            const monthEndDateStr = monthEndDate.getFullYear() + '-' + (monthEndDate.getMonth() > 9 ? monthEndDate.getMonth() + 1 : '0'
            + (monthEndDate.getMonth() + 1)) + '-' + (monthEndDate.getDate() > 9 ? monthEndDate.getDate() : '0' + monthEndDate.getDate());
            return { monthStartDate: monthStartDateStr, monthEndDate: monthEndDateStr };
        },
        // 获取上一个月
        getPreMonth() {
            const date = new Date();
            const year = date.getFullYear(); // 获取当前日期的年份
            const month = date.getMonth() + 1; // 获取当前日期的月份
            const day = date.getDay(); // 获取当前日期的日
            let days = new Date(year, month, 0);
            days = days.getDate(); // 获取当前日期中月的天数
            let year2 = year;
            // eslint-disable-next-line radix
            let month2 = parseInt(month) - 1;
            if (month2 === 0) {
                // eslint-disable-next-line radix
                year2 = parseInt(year2) - 1;
                month2 = 12;
            }
            let day2 = day;
            let days2 = new Date(year2, month2, 0);
            days2 = days2.getDate();
            if (day2 > days2) {
                day2 = days2;
            }
            if (month2 < 10) {
                month2 = '0' + month2;
            }
            const t2 = year2 + '-' + month2 + '-' + day2;
            const monthStartDateStr = year2 + '-' + month2 + '-01';
            const monthEndDateStr = year2 + '-' + month2 + '-' + days2;
            return { monthStartDate: monthStartDateStr, monthEndDate: monthEndDateStr };
        },
    },
};
</script>

<style lang="stylus">
    .empty-data{
        font-size 28rpx
        line-height 200rpx
        text-align center
        color #ccc
    }
    .data-currentsales
        height 100%
        .bottom
            height calc(100% - 230rpx)
            margin-top 15rpx
            padding 10rpx
            background-color #fff
            .address-types
                height calc(100% - 15rpx)
                margin-top 15rpx
                overflow-y auto
                padding 5px;
                .address-item
                    height 50rpx
                    display flex
                    border-radius 4rpx
                    margin-bottom 20rpx
                    .left
                        display flex
                        justify-content center
                        align-items center
                        width 30rpx
                        border-radius 4rpx 0 0 4rpx
                        padding 7rpx 6rpx
                        font-size 12rpx
                        color #fff
                        line-height 12rpx
                    .right
                        display flex
                        width calc(100% - 30rpx)
                        >div
                            flex 1
                            text-align center
                            &:nth-child(1)
                                position relative
                                .num
                                    color #5588F1
                                &:after
                                    content ''
                                    position absolute
                                    width 1px
                                    height 15rpx
                                    background #D7D7D7
                                    right 0
                                    top 20rpx
                            &:nth-child(2)
                                .num
                                    color #FA8436
                        .num
                            font-size 15rpx
                            margin-top 6rpx
                        .lable
                            font-size 12rpx
                            color #666666
                    &.color0
                        border 1px solid #D3DCF3
                        .left
                            background-color #3E67C6
                        .right
                            background rgba(62, 103, 198, 0.04)
                    &.color1
                        border 1px solid #C1E3DC
                        .left
                            background-color #4EA496
                        .right
                            background rgba(78, 164, 150, 0.04)
                    &.color2
                        border 1px solid #CFE6F8
                        .left
                            background-color #3089CC
                        .right
                            background rgba(48, 137, 204, 0.04)
        .top
            background-color #fff
            .top-time
                padding 15rpx
                border-bottom 1px solid #F0F0F0
                .time-select
                    box-shadow: 0 2rpx 4rpx 0 rgba(84, 148, 243, 0.2)
                    border-radius 4rpx
                    border 1px solid #D7D7D7
                    height 36rpx
                    line-height 36rpx
                    display flex
                    .split-line
                        width 4px
                        background-color #979EA7
                        height 1px
                        display inline-block
                        margin 18rpx 0 0 5rpx
                    .time
                        font-size 13rpx
                    .iconshijian
                        color #979EA7
                        margin 0 6rpx
                .time-types
                    display flex
                    margin-top 15rpx
                    .type-item
                        width calc(100% - 66rpx)
                        height 30rpx
                        text-align center
                        line-height 28rpx
                        background #FFFFFF
                        box-shadow 0 2rpx 4rpx 0 rgba(84, 148, 243, 0.2)
                        border-radius 4rpx
                        border 1px solid #D7D7D7
                        font-size 14rpx
                        color #666
                        &:nth-child(1)
                            margin-right 22rpx
                        &:nth-child(2)
                            margin-right 22rpx
                        &:nth-child(3)
                            margin-right 22rpx
                        &.active
                            background #3495FB
                            box-shadow 0 2rpx 4rpx 0 #5494F3
                            border-radius 4rpx
                            border 1px solid #0E84FF
                            color #fff
            .color-block
                padding 15rpx
                display flex
                .color-item
                    width calc(100% - 15rpx)
                    text-align center
                    padding 15rpx 0
                    .num
                        font-size 21rpx
                    .tip
                        font-size 12rpx
                        color #666666
                    &:nth-child(1)
                        background: rgba(85, 136, 241, 0.06)
                        margin-right 15rpx
                        .num
                            color #5588F1
                    &:nth-child(2)
                        background: rgba(250, 132, 54, 0.06)
                        .num
                            color #FA8436
</style>
